module.exports = __webpack_public_path__ + "media/images/bottomBanner-2a1f24ce43ba75addfc12126c87c189f.png";